import { render } from "./AddInsurance.vue?vue&type=template&id=e81eb122"
import script from "./AddInsurance.vue?vue&type=script&lang=js"
export * from "./AddInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/insurances/AddInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e81eb122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e81eb122', __exports__)) {
    console.log('reload')
    api.reload('e81eb122', __exports__)
  }
  
  module.hot.accept("./AddInsurance.vue?vue&type=template&id=e81eb122", () => {
    console.log('re-render')
    api.rerender('e81eb122', render)
  })

}


export default __exports__